import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/AboutUs.css";

import aboutImage1 from "../assets/894.webp";
import aboutImage2 from "../assets/892.webp";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="about-us" id="about">
      <h2 data-aos="fade-up">About GÜÇH DOORS</h2>
      <p className="about-description" data-aos="fade-up">
        GUCH Doors is dedicated to providing high-quality, durable, and
        aesthetically pleasing doors. With a strong focus on security,
        sustainability, and modern design, we ensure that each product meets the
        highest standards of craftsmanship and functionality.
      </p>

      <div className="about-content">
        <div className="about-item left" data-aos="fade-right">
          <img
            src={aboutImage1}
            alt="GUCH Doors in action"
            className="about-image"
          />
          <div className="about-text">
            <h3>Innovation in Every Door</h3>
            <p>
              We combine cutting-edge technology with exceptional design to
              create doors that not only look great but also perform beyond
              expectations.
            </p>
          </div>
        </div>

        <div className="about-item right" data-aos="fade-left">
          <img
            src={aboutImage2}
            alt="GUCH Doors in the industry"
            className="about-image"
          />
          <div className="about-text">
            <h3>Committed to Sustainability</h3>
            <p>
              GUCH Doors uses eco-friendly materials to craft doors that are not
              only beautiful but also contribute to a sustainable future.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
